import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AdvanceSearchComponent } from '../A2-utils/advance-search/advance-search.component';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { T2CardComponent } from '../../trip2-theme/components/t2-card/t2-card.component';
import { RiderService } from '../riders/rider.service';
import { MergeAccountService } from './merge-account.service';
import { Subscription } from 'rxjs/Subscription';
import { T2LoadingService } from '../../trip2-theme/components/t2-loading/t2-loading.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-merge-account-form',
  templateUrl: './merge-account-form.component.html',
  styleUrls: ['./merge-account-form.component.scss']
})
export class MergeAccountFormComponent implements OnInit, OnChanges, OnDestroy {
  public mergeAccountForm: FormGroup;
  protected isDisabledMergeAccountBtn  = true;
  protected isBaCard = true;
  protected keepRider = false;
  protected areSameRiders = false;
  protected isMergeCheckDisabled = false;
  protected mergingMask = false;
  protected submitValues: any;
  protected mainAccount = '';
  protected joinMergedArray = '';

  @Input() ridersSelectedInput: any[] = [];
  @Output() closeCard: EventEmitter<any> = new EventEmitter<any>();
  @Output() reloadSearchGrid: EventEmitter<any> = new EventEmitter<any>();
  @Output() riderIdKeepEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(AdvanceSearchComponent)           private advanceSearch: AdvanceSearchComponent;
  @ViewChild('msgbox')                  private msgBox: T2CardComponent;
  @ViewChild('areSameRidersCheck')    private areSameRidersCheck: ElementRef;
  // @ViewChild(LoadingMask)             private loadingMask         : LoadingMask;
  private subscriptions: Subscription = new Subscription();
  constructor(
    private fb: FormBuilder,
    private riderService: RiderService,
    private mergeAccountService: MergeAccountService,
    private loading: T2LoadingService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.createMergeForm();
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ridersSelectedInput']) {
      this.createMergeForm();
      if (this.ridersSelectedInput && this.ridersSelectedInput.length) {
        this.populateArray();
      }else {
        this.disableMergeControls();
      }
    }
  }

  populateArray() {
    if ( this.ridersSelectedInput.length > 1 ) {
      this.getInfoRiders(this.ridersSelectedInput.map(r => r.riderid));
      this.isMergeCheckDisabled = false;
    }else {
      this.disableMergeControls();
    }
  }
  disableMergeControls() {
    this.isMergeCheckDisabled = true;
    this.areSameRiders = false;
    this.isDisabledMergeAccountBtn = true;
    this.keepRider = false;
  }
  getDefaultPayor(arrayTest) {
    for (const payors of arrayTest.riderpayors){
      if (payors.isdefault) {
        return payors.payor.description;
      }
    }
  }
  createMergeForm() {
    this.mergeAccountForm = this.fb.group(
      {
        rideridkeep: null,
        rideridsmerge: this.fb.array([])
      }
    );
  }
  createMergeAccount(data) {
    return this.fb.group({
      fullname        : data.fullname,
      ssn             : data.ssn,
      address         : data.address,
      dob             : data.dobformatted,
      gender          : data.gender,
      payor           : this.getDefaultPayor(data),
      policy          : data.policy,
      mobile          : data.phonenumber,
      alternatephone  : data.alternatephonenumber,
      email           : data.email,
      riderid         : data.riderid,
      isinactive      : data.isinactive
    });
  }



  get accountForm(): FormArray {
    return this.mergeAccountForm.get('rideridsmerge') as FormArray;
  }

  onCheckSameRiders(event) {
    this.isDisabledMergeAccountBtn = !this.isDisabledMergeAccountBtn;
    event ? this.keepRider = true : this.keepRider = false;
  }
  onSelectRider(index) {
    this.mergeAccountForm.patchValue({
      rideridkeep : this.accountForm.controls[index].get('riderid').value
    });
  }
  submitMergeAccountForm(value) {
    this.submitValues = value;
    if ( value.rideridkeep !== null ) {
      // this.msgBox.open(true);
      this.viewAlertToMerge();
    }else {
      this.toastrAlertHelper.warning('Please select the rider to keep');
    }
  }
  onNotifyMerge(data) {
    this.areSameRiders = false;
    const riderIdKeep = this.mergeAccountForm.get('rideridkeep').value;
    if (data.success) {
      this.isDisabledMergeAccountBtn = true;
      this.isMergeCheckDisabled = false;
      this.mergingMask = false;
      this.toastrAlertHelper.success(data.message);
      this.createMergeForm();
      this.reloadSearchGrid.emit();
      this.riderIdKeepEmit.emit(riderIdKeep);
    }
  }
  onConfirm() {
    const arrayIds = [];
    if ( this.submitValues.rideridkeep !== null ) {
      for (const rider of this.submitValues.rideridsmerge) {
        if (this.submitValues.rideridkeep !== rider.riderid) {
          arrayIds.push(rider.riderid);
        }
      }
      const submit = {
        rideridkeep: this.submitValues.rideridkeep,
        rideridsmerge: arrayIds
      };
      this.isMergeCheckDisabled = true;
      this.mergingMask = true;

      this.subscriptions.add(this.mergeAccountService.putAccountsToMerge(submit).subscribe(
        data => {
          this.onNotifyMerge(data);
        }
      ));
    }
  }

  viewAlertToMerge() {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: `The following records will be merged To Rider ${this.mainAccount} : ${this.joinMergedArray}
             This transactions cannot be reversed. Are you sure you want to merge these records?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.onConfirm();
      }
    });
  }

  /**
   * @description trael los datos de los riders seleccionados y carga el form
   */
  getInfoRiders(ridersIds: number[]): void {
    // todo pendiente servicio para traer todos los riders
    if (ridersIds && ridersIds.length > 1) {
      this.loading.show('Loading Riders...');
      const subscription: Subscription[] = [];
      ridersIds.forEach((id, i) => {
        subscription[i] = this.riderService.getRiderPayor(id).subscribe(
          (success) => {
            this.accountForm.push(this.createMergeAccount(success));
            setTimeout(() => {
              subscription[i].unsubscribe();
              if (i === ridersIds.length - 1) {this.loading.hiden(); }
              }, 500);
          },
          error => {
            setTimeout(() => {
              subscription[i].unsubscribe();
              if (i === ridersIds.length - 1) {this.loading.hiden(); }
              }, 500);
          }
        );
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/merge-account/merge-account-form.component.ts